import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    // Check if user is admin based on role from user object
    // You would need to adjust this logic based on how your user roles are stored
    if (user && user.role === "admin") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }

    // Alternative: You could also make an API call to verify admin status
    // Example:
    // const checkAdminStatus = async () => {
    //   try {
    //     const response = await fetch("/api/check-admin-status", {
    //       headers: { Authorization: `Bearer ${user.token}` }
    //     });
    //     const data = await response.json();
    //     setIsAdmin(data.isAdmin);
    //   } catch (error) {
    //     console.error("Failed to check admin status:", error);
    //     setIsAdmin(false);
    //   }
    // };
    // if (user && user.token) {
    //   checkAdminStatus();
    // }
  }, [user]);

  return (
    <AdminContext.Provider value={{ isAdmin }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error("useAdmin must be used within an AdminProvider");
  }
  return context;
};

export default AdminContext;